module.exports = __webpack_public_path__ + "static/media/attack-number-9.eeae8230.png";